import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SearchSupportQuestionComponent } from './search-support-question.component';

@NgModule({
  imports: [
    MatDialogModule,
    CommonModule,
    FormsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
  ],
  declarations: [SearchSupportQuestionComponent],
  exports: [SearchSupportQuestionComponent],
})
export class SearchSupportQuestionModule {}
